import axios from "axios";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Timer from "../../../components/Timer";
import { buttonText } from "../../../utils/buttonText";

function StableDiffusionPage(props) {
  const { item, loadDatasetList } = props;

  const [prompt, setPrompt] = useState("");
  const [numImages, setNumImages] = useState(1);
  const [width, setWidth] = useState(512);
  const [height, setHeight] = useState(512);
  const [loading, setLoading] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);

  const generateImages = async () => {
    if (!prompt.trim()) {
      window.alert("Please enter a prompt");
      return;
    }
    setLoading(true);
    setPreviewImages([]);
    try {
      const response = await axios.post("/datasets/generate/sd15", {
        dataset_name: item.name,
        prompt: prompt.trim(),
        num_images: Number(numImages),
        width: Number(width),
        height: Number(height),
      });
      const images = response.data?.images || [];
      setPreviewImages(images);
      loadDatasetList();
      window.alert(
        `Successfully generated ${response.data?.generated_count || images.length} image(s) and added to dataset '${item.name}'`
      );
    } catch (error) {
      const errorMsg = error.response?.data || error.message;
      window.alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stable-diffusion-page">
      <p>Generate images from text prompts using Stable Diffusion 1.5 and add them to the current dataset.</p>
      <Form.Group className="mb-3">
        <Form.Label>Prompt</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g. a photo of a cat sitting on a chair"
        />
      </Form.Group>
      <div className="sd-params-row">
        <Form.Group>
          <Form.Label>Count</Form.Label>
          <Form.Control
            type="number"
            min={1}
            max={8}
            value={numImages}
            onChange={(e) => setNumImages(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Width</Form.Label>
          <Form.Control
            type="number"
            min={256}
            max={1024}
            step={64}
            value={width}
            onChange={(e) => setWidth(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Height</Form.Label>
          <Form.Control
            type="number"
            min={256}
            max={1024}
            step={64}
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          />
        </Form.Group>
      </div>
      <button
        type="button"
        className="org-btn org-btn-primary"
        onClick={generateImages}
        disabled={loading}
      >
        {buttonText(loading ? (
          <span>
            <Timer loadingStates={[loading]} />
          </span>
        ) : (
          "Generate"
        ))}
      </button>
      {previewImages.length > 0 && (
        <div className="sd-preview-grid">
          {previewImages.map((img, idx) => (
            <img
              key={idx}
              src={`data:image/png;base64,${img}`}
              alt={`generated-${idx}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default StableDiffusionPage;
